import { FC } from 'react';

import { Stack, StackProps, styled } from '@mui/material';

import { SvgIconProps } from '../../../../../../components/SvgIcon';
import Typography from '../../../../../../components/Typography';

interface IconNamePairProps {
  icon: FC<SvgIconProps<'svg', {}>>;
}

export const IconNamePair = styled(({ icon: Icon, children, ...props }: StackProps & IconNamePairProps) => (
  <Stack direction="row" alignItems="center" gap={2} {...props}>
    <Icon size={20} />
    <Typography variant="textXsBold" component="h3" color="primary">
      {children}
    </Typography>
  </Stack>
))(({ theme }) => ({}));
